import { render } from "./DateWidget.vue?vue&type=template&id=5d51e45f&scoped=true"
import script from "./DateWidget.vue?vue&type=script&lang=js"
export * from "./DateWidget.vue?vue&type=script&lang=js"

import "./DateWidget.vue?vue&type=style&index=0&id=5d51e45f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d51e45f"]])

export default __exports__